<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px">
      <!-- 验证码 -->
      <section slot="verifyCode" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.verifyCode">
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >{{ smsTime || '获取短信验证码' }}</article>
        </el-input>
      </section>
    </qx-custom-form>
  </section>
</template>

<script>
import { findpwdSendValidCode, findpwdCheckValidCode } from 'api';
export default {
  data () {
    return {
      smsTime: 0,
      smsTimer: null,
      baseForm: {
        form: [
          {
            label: '手机号码',
            value: 'linkPhone',
            type: 'input',
          },
          {
            label: '验证码',
            value: 'verifyCode',
            slot: true,
          },
        ],
        rules: {
          linkPhone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
          ],
          verifyCode: [
            { required: true, message: '请输入手机验证码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (formData.linkPhone && formData.verifyCode) {
          let resCheckValidCode = await findpwdCheckValidCode({
            phone: formData.linkPhone,
            verifyCode: formData.verifyCode,
          });
          if (resCheckValidCode === 'N') {
            this.$message.error('验证码错误！请输入正确的验证码！');
            return null;
          }
        }
        // 下面两个参数不知道为什么要，反正跟以前一样加上
        formData.phone = formData.linkPhone;
        formData.validCode = formData.verifyCode;
      }
      return formData;
    },
    async getSms () { // 获取短信验证码
      const phone = await this.$refs.baseForm.getVal('linkPhone');
      if (!(/^\d{11}$/.test(phone))) {
        this.$message.warning('亲，请输入正确的手机号码！');
        return;
      }
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      const res = await findpwdSendValidCode({
        phone,
      });
      if (!res.failed) {
        this.$message.success('验证码已发送，请可留意查收');
        clearInterval(this.smsTimer);
        this.smsTimer = setInterval(() => {
          this.smsTime--;
          if (this.smsTime <= 0) {
            this.smsTime = 0;
            clearInterval(this.smsTimer);
          }
        }, 1000);
      } else {
        this.smsTime = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.getCodeBtn {
  padding-right: 8px;
}
</style>
